export default "__VITE_ASSET__328a19bb__"